import { TankTrouble } from "./tanktrouble.js";
import { animate, utils } from "animejs";
import { Backend } from "./backend.js";
import { Caches } from "./caches.js";
import { Inputs } from "./inputs.js";
import { Utils } from "./utils.js";

TankTrouble.ControlsBox = {
    // jQuery objects.
    controls: null,
    controlsContent: null,
    controlsTabBottom: null,
    controlsOptions: {},
    controlsBackground: null,

    // State.
    initialised: false,
    showing: false,
    playerId: null,

    _initialise() {
        this.controls = $("<div class='box noselect' id='controlsBox'/>");
        this.controlsContent = $("<div class='content'/>");
        this.controlsTabBottom = $("<div class='tab bottom'/>");
        this.controlsBackground = $("<div class='boxbackground'/>");

        this.controlsContent.append(this.controlsTabBottom);

        const inputSetIds = Inputs.getAllInputSetIds();
        for (let i = 0; i < inputSetIds.length; ++i) {
            const controlsOption = $("<div class='button' title=''/>");

            Utils.addImageWithClasses(controlsOption, "standard", `tankInfo/${inputSetIds[i]}.png`);
            Utils.addImageWithClasses(controlsOption, "active", `tankInfo/${inputSetIds[i]}Active.png`);

            controlsOption.tooltipster({ side: "top" });
            controlsOption.on("mouseup", event => {
                if (this.showing) {
                    Inputs.switchInputManager(this.playerId, inputSetIds[i]);
                    this.hide();
                    TankTrouble.TankInfoBox.hide();
                }
            });

            this.controlsOptions[inputSetIds[i]] = controlsOption;
            this.controlsContent.append(controlsOption);
        }

        this.controls.append(this.controlsContent);

        $("body").append(this.controlsBackground);
        $("body").append(this.controls);

        this.controlsBackground.hide();
        this.controls.hide();

        this.controlsBackground.click(event => {
            if (this.showing) {
                this.hide();
            }
        });

        this.initialised = true;
    },

    show(x, y, playerId, preferredRadius) {
        if (!this.initialised) {
            this._initialise();
        }

        this.playerId = playerId;

        const inputSetIds = Inputs.getAllInputSetIds();
        for (let i = 0; i < inputSetIds.length; ++i) {
            const controlsOption = this.controlsOptions[inputSetIds[i]];
            controlsOption.toggle(inputSetIds[i] !== Inputs.getAssignedInputSetId(playerId));
            controlsOption.tooltipster("content", Inputs.getInputSetName(inputSetIds[i]));

            const otherPlayerId = Inputs.getAssignedPlayerId(inputSetIds[i]);
            if (otherPlayerId !== null) {
                Backend.getPlayerDetails(otherPlayerId, Caches.getPlayerDetailsCache())
                    .then(result => {
                        if (typeof result === "object" && Inputs.getAssignedPlayerId(inputSetIds[i]) === otherPlayerId) {
                            controlsOption.tooltipster("content", `Switch with ${result.getUsername()}`);
                        }
                    });
            }
        }

        this.controls.show();
        this.controlsBackground.fadeIn(200);

        this.showing = true;

        Utils.placeBox(this.controls, x, y, "top", preferredRadius, preferredRadius, 30, 35);

        this.controls.css({ opacity: 0 });
        utils.set(this.controls[0], { scale: 0.1 });
        animate(this.controls[0], { scale: 1, duration: 300, ease: "outBack" });
        this.controls.animate({ opacity: 1 }, { duration: 200, queue: false });
    },

    hide() {
        if (!this.initialised) {
            this._initialise();
        }

        animate(this.controls[0], {
            scale: 0,
            duration: 200,
            ease: "inQuad",
            onComplete: () => {
                this.controls.hide();
                utils.set(this.controls[0], { scale: 1 });
            }
        });
        this.controls.animate({ opacity: 0 }, { duration: 200, queue: false });
        this.controlsBackground.fadeOut(200);

        this.showing = false;
    }
};
